import { Plus, X } from "lucide-react";
import { FormEvent, useState } from "react";
import type { ScoreColumn } from "../types";

type Props = {
  onClose: () => void;
  onCreate: (name: string, weight: number, mode: ScoreColumn["mode"]) => Promise<void>;
  column?: ScoreColumn;
  hasScores?: boolean;
};

export default function ScoreColumnModal({ onClose, onCreate, column, hasScores = false }: Props) {
  const [name, setName] = useState(column?.shortLabel || "");
  const [weight, setWeight] = useState(column?.weight || 1);
  const [mode, setMode] = useState<ScoreColumn["mode"]>(column?.mode || "direct");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (column && mode !== column.mode && hasScores && !window.confirm(`Đổi cách tính sẽ xóa các điểm đã nhập trong cột “${column.shortLabel}”. Tiếp tục?`)) return;
    setSaving(true);
    setError("");
    try { await onCreate(name.trim(), weight, mode); }
    catch (issue) { setError(issue instanceof Error ? issue.message : "Không thể thêm cột điểm."); }
    finally { setSaving(false); }
  };

  return <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
    <section className="compact-modal score-column-modal" role="dialog" aria-modal="true" aria-labelledby="score-column-title">
      <header><div className="compact-modal__icon"><Plus /></div><div><span className="modal-kicker">BẢNG ĐIỂM</span><h2 id="score-column-title">{column ? "Cấu hình cột điểm" : "Thêm cột điểm"}</h2></div><button className="icon-button" onClick={onClose} aria-label="Đóng"><X /></button></header>
      <form onSubmit={(event) => void submit(event)}>
        <label htmlFor="new-score-name">Tên cột điểm</label>
        <input id="new-score-name" autoFocus maxLength={40} required placeholder="Ví dụ: Giữa kỳ 2" value={name} onChange={(event) => setName(event.target.value)} />
        <label htmlFor="new-score-weight">Hệ số</label>
        <select id="new-score-weight" value={weight} onChange={(event) => setWeight(Number(event.target.value))}><option value={1}>Hệ số 1</option><option value={2}>Hệ số 2</option><option value={3}>Hệ số 3</option></select>
        <fieldset><legend>Cách tính điểm</legend>
          <label><input type="radio" name="score-mode" checked={mode === "direct"} onChange={() => setMode("direct")} /><span><b>Nhập điểm trực tiếp</b><small>Mỗi học sinh có một ô điểm.</small></span></label>
          <label><input type="radio" name="score-mode" checked={mode === "sum"} onChange={() => setMode("sum")} /><span><b>Trắc nghiệm + tự luận</b><small>Nhập hai phần, hệ thống tự tính tổng khi đủ điểm.</small></span></label>
        </fieldset>
        {error && <p className="column-modal-error" role="alert">{error}</p>}
        <footer><span /><button className="btn-secondary" type="button" onClick={onClose}>Hủy</button><button className="btn-primary-small" disabled={saving || !name.trim()} type="submit">{saving ? "Đang lưu…" : column ? "Lưu thay đổi" : "Thêm cột"}</button></footer>
      </form>
    </section>
  </div>;
}
